var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5029 8.50965L9.94288 4.22965C4.19288 1.34965 1.83288 3.70965 4.71288 9.45965L5.58288 11.1996C5.83288 11.7096 5.83288 12.2996 5.58288 12.8096L4.71288 14.5396C1.83288 20.2896 4.18288 22.6496 9.94288 19.7696L18.5029 15.4896C22.3429 13.5696 22.3429 10.4296 18.5029 8.50965ZM15.2729 12.7496H9.87288C9.46288 12.7496 9.12288 12.4096 9.12288 11.9996C9.12288 11.5896 9.46288 11.2496 9.87288 11.2496H15.2729C15.6829 11.2496 16.0229 11.5896 16.0229 11.9996C16.0229 12.4096 15.6829 12.7496 15.2729 12.7496Z",
    fill: "#3369FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.214ed2e9a483ebe97ed46022efd75dcd.svg";
export { ForwardRef as ReactComponent };